//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import BackendServices from "@/services/backend-services.js";

export default {
  name: "AutomaticUploadsHistoryTable",
  props: ["tableClass", "bordered", "typeName"],
  components: {
    Table,
  },
  mounted: function () {
    this.isLoading = true;
    BackendServices.getSchedulingHistory(this.pagination).then((response) => {
      this.data = Array.isArray(response.data) ? response.data : [];
      this.recordsTotal = response.headers["x-total-count"];
      this.pagination.recordsTotal = this.recordsTotal;
      this.isLoading = false;
    });
  },
  data: function () {
    return {
      separator: "horizontal",
      pagination: {
        page: 1,
        rowsPerPage: 10,
        recordsTotal: 0,
      },
      recordsTotal: null,
      isLoading: false,
      data: [],
      columns: [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: (row) => (row.id ? row.id : "N/A"),
        },
        {
          name: "name",
          label: "Agendamento",
          align: "left",
          field: (row) => (row.name ? row.name : "N/A"),
        },
        {
          name: "run_time",
          align: "left",
          label: "Hora",
          field: (row) => (row.run_timestamp ? row.run_timestamp : "N/A"),
        },
        {
          name: "status",
          align: "left",
          label: "Estado",
          field: (row) => (row.status ? row.status : "N/A"),
          icon: {
            conditional: true,
            created: {
              name: "mdi-alert-circle-outline",
              label: "Pendente",
              color: "yellow-4",
            },
            started: {
              name: "mdi-cached",
              label: "Iniciado",
              color: "blue-5",
            },
            successful: {
              name: "mdi-check-circle-outline",
              label: "Válido",
              color: "green-4",
            },
            failure: {
              name: "mdi-close-circle-outline",
              label: "Inválido",
              color: "red-4",
            },
          },
        },
      ],
    };
  },
  methods: {
    askForData: function (event) {
      this.pagination = event.pagination;
      this.isLoading = true;
      BackendServices.getSchedulingHistory(event.pagination).then((response) => {
        this.data = Array.isArray(response.data) ? response.data : [];
        this.recordsTotal = response.headers["x-total-count"];
        this.isLoading = false;
      });
    },
    emitLine(event) {
      this.$emit("clicked-row", { ...event });
    },
  },
};
